import { LoadableAfterPaint } from '@confluence/loadable';

export const EditorPageCoverPictureEntry = LoadableAfterPaint({
	loader: async () => {
		const { EditorPageCoverPictureEntry } = await import(
			/* webpackChunkName: "loadable-EditorCoverPictureEditorPageCoverPictureEntry" */ '../src/EditorCoverPicture/EditorPageCoverPictureEntry.tsx'
		);
		return EditorPageCoverPictureEntry;
	},
});
